import React from "react";
import {
    Typography,
    Grid,
    Avatar,
    Paper,
    makeStyles,
    Button,
    IconButton,
} from "@material-ui/core";
import AutorenewIcon from "@material-ui/icons/Autorenew";

import MainScreen from "./templates/MainScreen";
import { useTranslation } from "react-i18next";
import { GetOpponent } from "../../viewmodel/providers/getOpponent";
import { useGetResource } from "../../viewmodel/hooks/getResource";

import { getRedisMatchMakingSimple } from "../../utils/redisPubSub";
import DefinedOpponent from "../components/DefinedOpponent";
import UndefinedOpponent from "../components/UndefinedOpponent";
import LookingForOpponent from "../components/LookingForOpponent";
import UserInfo from "../../model/userInfo";

const useStyles = makeStyles((theme) => ({
    avatar: {
        width: "130px",
        height: "130px",
        marginTop: "40%",
        marginLeft: "20px",
        marginRight: "20px",
    },
    centerHorizontal: {
        marginLeft: "auto",
        marginRight: "auto",
    },
    centerVertical: {
        marginTop: "auto",
        marginBottom: "auto",
    },
    fullHeight: {
        height: "100%",
    },
    blackButton: {
        backgroundColor: theme.palette.primary.main,
        "&:hover": {
            background: theme.palette.primary.main,
        },
        width: "100%",
    },
    blackButtonWidth: {
        width: "40%",
        maxWidth: "300px",
    },
    refresh: {
        width: "1.5em",
        height: "1.5em",
    },
    noPadding: {
        padding: "0",
        margin: "auto 0",
    },
    middleGrid: {
        maxWidth: "800px",
    },
    lowerGrid: {
        maxWidth: "600px",
    },
    blackText: {
        color: "black",
    },
    flex1: {
        flexGrow: 1,
    },
    centerText: {
        textAlign: "center",
    },
}));

export default function AcceptOpponent(): JSX.Element {

    const resource = useGetResource(GetOpponent);

    if (resource.isFilled) {
        return <AcceptOpponentScreen loaded={true} />;
    }
    if (resource.failed) {
        return <Typography>An error has happened, please try again later</Typography>;
    } else {
        return <AcceptOpponentScreen loaded={false} />;
    }
}

type AcceptOpponentScreenProps = {
    loaded?: boolean;
    user?: UserInfo;
}

export function AcceptOpponentScreen({ loaded, user }: AcceptOpponentScreenProps): JSX.Element {
    const { t } = useTranslation();
    const classes = useStyles();
    let avatar;

    if (loaded) {
        if (user !== undefined) {
            avatar =  <DefinedOpponent user={user} />;
        } else {
            avatar = <UndefinedOpponent />;
        }
    } else {
        avatar = <LookingForOpponent />;
    }


    const stats = loaded &&
        (
            <Grid
                container direction="row" justify="space-evenly"
                className={`${classes.centerHorizontal} ${classes.middleGrid}  ${classes.flex1}`}
            >
                <Paper elevation={0}>
                    <Avatar className={`${classes.blackText} ${classes.centerHorizontal}`}>
                        6
                    </Avatar>
                    <Typography variant="h6" className={`${classes.centerText}`}>
                        legenda
                    </Typography>
                </Paper>
                <Paper elevation={0}>
                    <Avatar className={`${classes.blackText} ${classes.centerHorizontal}`}>
                        120
                    </Avatar>
                    <Typography variant="h6" className={`${classes.centerText}`}>
                        legenda
                    </Typography>
                </Paper>
                <Paper elevation={0}>
                    <Avatar className={`${classes.blackText} ${classes.centerHorizontal}`}>
                        4082
                    </Avatar>
                    <Typography variant="h6" className={`${classes.centerText}`}>
                        legenda
                    </Typography>
                </Paper>
                <Paper elevation={0}>
                    <Avatar className={`${classes.blackText} ${classes.centerHorizontal}`}>
                        45
                    </Avatar>
                    <Typography variant="h6" className={`${classes.centerText}`}>
                        legenda
                    </Typography>
                </Paper>
            </Grid>
        );
    const lowerButtons = loaded &&
        (
            <Grid
                container justify="space-between"
                className={`${classes.centerHorizontal} ${classes.lowerGrid}  ${classes.flex1}`}
            >
                <IconButton
                    aria-label="search" classes={{ root: classes.noPadding }}
                    onClick={() => getRedisMatchMakingSimple()?.rejectAndLook()}
                >
                    <AutorenewIcon classes={{ root: classes.refresh }} />
                </IconButton>
                <Button
                    color="primary"
                    className={`${classes.centerVertical} ${classes.blackButton} ${classes.blackButtonWidth}`}
                    onClick={() => getRedisMatchMakingSimple()?.sendIsReady()}
                >
                    <Typography variant="h4" color="secondary">
                        {t("accept-opponent.ok")}
                    </Typography>
                </Button>

            </Grid>
        );

    return (
        <MainScreen lower={false} back={true}>
            <Grid container direction="column" justify="space-around" classes={{ root: classes.fullHeight }}>
                {avatar}
                {stats}
                {lowerButtons}
            </Grid>
        </MainScreen>
    );
}
